// Helpers for building FormData for the presale_mls_creation endpoint.
//
// FormData.append() coerces `undefined`/`null` into the literal strings
// "undefined"/"null". For MLS uploads an absent value must be sent as an
// empty field, not the string "undefined". Use appendField so empty stays
// empty. File objects (and any non-nullish value) pass through untouched.

export function appendField(formData, key, value) {
  formData.append(key, value == null ? '' : value);
}
